import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import fr from 'element-plus/es/locale/lang/fr'
import '@mdi/font/css/materialdesignicons.min.css'
import router from './router'

const app = createApp(App)
app.use(router)
app.use(ElementPlus, { locale: fr })
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.mount('#app')
